import { SHARED_DATA_STATUS } from "@/domain/sharedData/constants"

export type StatusCount = { code?: string; count?: number }

export type StatusGroup = {
  // The share status, also the status filter a click applies.
  code: string
  count: number
}

// Statuses of the distribution tile and of the status filter (ADR 0009, D1), in this order: one
// line per status, so that a line and the filter it applies always agree. "archive" is left out.
export const DISTRIBUTION_STATUSES: string[] = [
  SHARED_DATA_STATUS.ASKED,
  SHARED_DATA_STATUS.ACCEPTED,
  SHARED_DATA_STATUS.COMPLETED,
  SHARED_DATA_STATUS.DENIED,
  SHARED_DATA_STATUS.REVOKED,
  SHARED_DATA_STATUS.CANCELLED,
  SHARED_DATA_STATUS.CLOSED,
]

export const countOf = (counts: StatusCount[] | undefined, code: string) =>
  (counts ?? []).find(count => count.code === code)?.count ?? 0

// Every status of the filter is listed, even at zero, so that the legend reads like the filter.
export const getStatusGroups = (counts: StatusCount[] | undefined): StatusGroup[] =>
  DISTRIBUTION_STATUSES.map(code => ({ code, count: countOf(counts, code) }))

// Share of each status in the bar, in percent; empty statuses take no room.
export const getDistribution = (groups: StatusGroup[]) => {
  const total = groups.reduce((sum, group) => sum + group.count, 0)
  return {
    total,
    segments: groups
      .filter(group => group.count > 0)
      .map(group => ({ ...group, percent: (group.count / total) * 100 })),
  }
}
